module.exports = __webpack_public_path__ + "static/royal-mail-c76a56d3eef2e4b3b030306e926d7ab8.svg";